import { Block, palette, SvgIcon, spacing, Touchable, Typography } from "@stepapp/ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { type Insets, StyleProp, StyleSheet, ViewStyle } from "react-native";
import { AppStorage } from "../../services/AppStorage";
import { useDisplayIntercom } from "../../services/Intercom";

const hitSlops: Insets = {
  top: spacing.unit * 2,
  left: spacing.unit * 2,
  right: spacing.unit * 2,
  bottom: spacing.unit * 2,
};

type Props = {
  label?: string;
  style?: StyleProp<ViewStyle>;
  variant?: "default" | "primary";
};

const IntercomButton = ({ label, style, variant = "default" }: Props) => {
  const { t } = useTranslation();
  const countryCode = AppStorage().get("countryCode");
  const displayIntercom = useDisplayIntercom(countryCode);

  const isPrimary = variant === "primary";
  const iconColor = isPrimary ? palette.common.white : palette.primary.accent;
  const textColor = isPrimary ? palette.common.white : palette.primary.accent;

  return (
    <Touchable
      hitSlop={hitSlops}
      onPress={() => displayIntercom()}
      style={[styles.container, isPrimary && styles.primaryVariant, style]}
    >
      <Block justifySpace row>
        <SvgIcon color={iconColor} name="chat2" size={18} />
        <Typography
          type="accent"
          variant="paragraphBold"
          style={[styles.label, { color: textColor }]}
        >
          {label || t("common.chat")}
        </Typography>
      </Block>
    </Touchable>
  );
};

export default React.memo(IntercomButton);

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#CCD",
    borderRadius: spacing.radius * 5,
    height: 41,
    paddingLeft: spacing.unit * 1.5,
    paddingRight: spacing.unit * 2,
    marginLeft: spacing.unit,
    marginRight: spacing.unit,
    justifyContent: "center",
  },
  primaryVariant: {
    backgroundColor: palette.primary.accent,
  },
  label: {
    marginLeft: spacing.unit * 0.5,
  },
});
